import { isEmptyString } from 'mytribus-commons';
import { Property as BaseProperty, User } from 'displet-sdk-js';

export default class Property extends BaseProperty {
  /** @return {Promise<null|User>} */
  async getUserByAgentKey(key) {
    const agentOffice = this.listing.agent_office;

    const { user_id: userId } = agentOffice[key];

    if (!isEmptyString(userId)) {
      return User.findById(userId);
    }

    const mlsId = agentOffice[key][`${key}_mls_id`];

    if (!isEmptyString(mlsId)) {
      const users = await User.search({
        mls_id: mlsId,
        per_page: 1,
      });

      if (!users.isEmpty()) {
        return users.first();
      }
    }

    return null;
  }
}
